
var $ = require('jquery');

function HTTPService() {

    this.post = function (url, json) {
        var jqueryPromise = $.ajax({
            url: url,
            data : JSON.stringify(json),
            contentType : 'application/json',
            type: 'POST',
            xhrFields: {
                'withCredentials': true
            },
            crossDomain: true
        });
        return Promise.resolve(jqueryPromise);
    };

    this.get = function (url, query) {
        var options = {
            url: url,
            data : query,
            type: 'GET',
            crossDomain: true
        };
        options.xhrFields = {
            withCredentials: true
        };
        var jqueryPromise = $.ajax(options);
        return Promise.resolve(jqueryPromise);
    };

    this.setToken = function (token) {
        var tokenBase64 = btoa(token + '0');
        $.ajaxSetup({
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'Basic ' + tokenBase64);
            }
        });
    };
}

module.exports = new HTTPService();


//////////////////
// WEBPACK FOOTER
// ./form/components/utils/HTTPService.js
// module id = 11
// module chunks = 0 1